<template>
  <WhatsAppSettings type="REPORT_CARE" />
</template>

<script>
import WhatsAppSettings from "../templates/WhatsApp/WhatsAppSettings";

export default {
  name: "WhatsAppSettingsReportMedicine",

  components: {
    WhatsAppSettings,
  },
};
</script>